import { css } from "../Styles";

export enum ListStyle_Types {
    horizontal = "horizontal",
    vertical = "vertical",
    group = "group",
    centeredGroup = "centeredGroup",
  }
  
  export const CreateListStyle = (listStyle?:ListStyle_Types|string) => {
    let listDirection;
  
    switch (listStyle) {
      case ListStyle_Types.vertical:
        listDirection = { ...css.listStyle_vertical }
      break;
      case ListStyle_Types.group:
        listDirection = { ...css.listStyle_group }
      break;
      case ListStyle_Types.centeredGroup:
        listDirection = { ...css.listStyle_centeredGroup }
      break;
      case ListStyle_Types.horizontal:
        default:
        listDirection = { ...css.listStyle_horizontal }
      break;
    }
    return {
        listDirection
    }
  }
  
  // export default CreateListStyle

// Eksempel på brug (Maja) - se evt. select.tsx og input.tsx
//
// Import af definition:
// import CreateListStyle, { ListStyle_Types } from "../../Definitions/listStyles";
// 
// Indsæt under props for det pågældende component:
// listStyle?: ListStyle_Types|string,
//
// oprettelse af const på det enkelte component til brug i kald:
// const { seperatorPosition, listDirection } = useMemo(() => CreateListStyle(listStyle), [listStyle]);
//
// Kald på det enkelte component på forskellige div'er, hvor stylingen ønskes:
// <div style={seperatorPosition as React.CSSProperties}/>
// <div style={listDirection as React.CSSProperties}>